import React, { FC, memo } from "react";

import { SocAuthCallbackScreen } from "../";

export const AccountVkRedirect: FC = memo(() => <SocAuthCallbackScreen network="vk" />);
